import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

export interface KpdCode {
  id: number;
  code: string;
  name: string;
  name_en: string | null;
  description: string | null;
  cpa_code: string | null;
  nkd_category: string | null;
  is_active: boolean;
}

export interface KpdCodeSearchResponse {
  suggested: KpdCode[];
  all: KpdCode[];
}

export interface KpdCodeSearchRequest {
  query: string;
  limit?: number;
}

@Injectable({
  providedIn: 'root'
})
export class KpdCodeApiService {

  constructor(private http: HttpClient) {
  }

  /**
   * Search for KPD codes by code or name
   * @param request - Search query and result limit
   * @returns Observable with suggested and all matching codes
   */
  search(request: KpdCodeSearchRequest): Observable<KpdCodeSearchResponse> {
    const params = new HttpParams()
      .set('query', request.query)
      .set('limit', (request.limit || 50).toString());

    return this.http.get<KpdCodeSearchResponse>(
      `${environment.apiUrl}/api/kpd-codes/search`,
      {params}
    );
  }

  /**
   * Get default KPD code for a specific vehicle type
   * @param vehicleType - Vehicle type enum value (e.g., 'personal', 'heavy', 'motorcycle')
   * @returns Observable with the default KPD code for that vehicle type
   */
  getForVehicleType(vehicleType: string): Observable<KpdCode> {
    return this.http.get<KpdCode>(
      `${environment.apiUrl}/api/kpd-codes/vehicle-type/${vehicleType}`
    );
  }

  /**
   * Get KPD code details by code
   * @param code - KPD code (e.g., '29.10.21')
   * @returns Observable with the KPD code details
   */
  getByCode(code: string): Observable<KpdCode> {
    return this.http.get<KpdCode>(
      `${environment.apiUrl}/api/kpd-codes/${encodeURIComponent(code)}`
    );
  }
}
